var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tune_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/image/tune_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9H15V3H17V5H21V7H17V9ZM3 7V5H13V7H3ZM3 19V17H9V19H3ZM13 21V19H21V17H13V15H11V21H13ZM7 11V9H9V15H7V13H3V11H7ZM21 13V11H11V13H21Z",
    fill: "#959BAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.f4677995798838dd85493266a9087e6b.svg";
export { ForwardRef as ReactComponent };